import axios from "axios"
import { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { isLoggedIn } from "../user/User"

const RequestPasswordReset = () => {
    const [email, setEmail] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()
    useEffect(() => {
        if (isLoggedIn()) {
            navigate("/")
        }
    })

    async function requestPasswordReset() {
        setIsLoading(true)
        axios.get(process.env.REACT_APP_API_URL + "/reset/" + email).then(_ => {
            toast.success("You received an email to reset your password.")
            navigate("/login")
        }).catch(error => {
            setIsLoading(false)
            if (error.response) {
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Invalid request.")
                    return
                } else if(statusCode === 404) {
                    toast.error("There is no user with this email address.")
                    return
                } else if(statusCode === 409) {
                    toast.error("Please wait until sending the next request.")
                    return
                }
            }
            toast.error("Internal error")
        })
    }

    const handleSubmit = async e => {
        e.preventDefault()
        requestPasswordReset(email, navigate)
    }

    return (
        <div className="login-page">
            <div className="login-box">
                <div className="card card-outline card-primary">
                    <div className="card-header text-center">
                        <h1>{process.env.REACT_APP_APP_NAME}</h1>
                    </div>
                    <div className="card-body">
                        <p className="login-box-msg">Insert your email address to reset your password.</p>
                        <form onSubmit={handleSubmit}>
                            <div className="input-group mb-3">
                                <input type="email" className="form-control" placeholder="Email address" required value={email} onChange={e => setEmail(e.target.value)} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-envelope"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    {
                                        isLoading ? 
                                        <button type="submit" className="btn btn-primary btn-block" disabled>Sending email...</button>
                                        :
                                        <button type="submit" className="btn btn-primary btn-block">Reset password</button>
                                    }
                                </div>
                            </div>
                        </form>

                        <p className="mt-3 mb-1">
                            <Link to="/login">Login</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
 
export default RequestPasswordReset